import React from 'react';
import { Typography, Stack, Divider } from '@mui/material';

import useStats from './hooks/useStats';

import { useStyles } from './styles';

const GamecastStats = () => {
  const { stats } = useStats();

  const classes = useStyles();

  if (!stats) {
    return null;
  }

  return (
    <Stack sx={classes.root}>
      {[
        {
          title: 'Video Resolution',
          value: `${stats.frameWidth}x${stats.frameHeight}`,
        },
        {
          title: 'Received(kB)',
          value: stats.packetsReceived,
        },
        {
          title: 'Frames Decoded',
          value: stats.framesDecoded,
        },
        {
          title: 'Packets Lost',
          value: stats.packetsLost,
        },
        {
          title: 'Bitrate(kbps)',
          value: Math.round(stats.totalDecodeTime),
        },
        {
          title: 'Framerate',
          value: stats.framesPerSecond,
        },
        {
          title: 'Frames Dropped',
          value: stats.framesDropped,
        },
        {
          title: 'Net RTT(ms)',
          value: Math.round(stats.totalProcessingDelay),
        },
        {
          title: 'Transfer Speed(MBs)',
          value: stats.transferSpeed,
        },
        {
          title: 'Connection Speed(MBPs)',
          value: stats.connectionSpeed,
        },
      ].map(({ title, value }, index) => (
        <Stack sx={classes.row} key={`${title}:${index}`}>
          <Typography sx={classes.text}>{title}</Typography>
          <Divider sx={classes.divider} />
          <Typography sx={classes.text}>{value}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default GamecastStats;
